import { useEffect, useRef } from "react";

export const useScrollLock = (isLocked: boolean) => {    
    const originalStyleRef = useRef<string | null>(null);
    
    useEffect(() => {
        
        if (originalStyleRef.current === null) {
            originalStyleRef.current = window.getComputedStyle(document.body).overflow;
        }
        
        if (isLocked) {
            document.body.style.overflow = "hidden";
        } else {
            
            document.body.style.overflow = originalStyleRef.current;
        }
        
        return () => {
            document.body.style.overflow = originalStyleRef.current || "";
        };
    }, [isLocked]);
};
